// Booking pages' product links remembered for the product page's back arrow (Peter, COOL 201, 2026-10-07). In the footer
// app bundle (gulpfile.js), so every booking page has it with no page of its own edited: the booking view and the shared
// view (/booking/<id>/…/view/), the confirmation page (/booking/<id>/<token>/) and the ticket (/ticket/…, /voucher/…).
//
// A click or a middle-click there on a link to another page of this site (not a booking, ticket, voucher or account
// page: the title, ⋯ View original listing, the Activity details tab's View original listing, the confirmation card's
// title) stores localStorage tmBookingBack {path: the link's path, back: this page's address, kind: 'ticket' | 'booking',
// at: ms}. The link opens as before (a new window); the product page there (sections/single-product/booked-bar.php,
// booked-bar.js) takes the entry when its path is that page's and it is under 2 minutes old, and shows the arrow back
// here. Why not the referrer: the booking pages send Referrer-Policy: strict-origin (Prashant, 2026-10-06), so the
// product page only ever sees our origin. Storage as tmCruise's (the shore in-port bar): no consent category of its own
// (TmConsent lists it in none, as tmCruise), and storage switched off (private mode) means no arrow.
(function () {
    'use strict';

    var KEY = 'tmBookingBack';
    var SOURCE_PATH = /^\/(booking|ticket|voucher)\//;
    var NOT_A_PRODUCT_PATH = /^\/(booking|ticket|voucher|account)(\/|$)/;

    if (!SOURCE_PATH.test(window.location.pathname)) {
        return;
    }

    function remember(e) {
        var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
        if (!link) {
            return;
        }
        var url;
        try {
            url = new URL(link.href, window.location.href);
        } catch (err) {
            return;
        }
        if (url.origin !== window.location.origin || NOT_A_PRODUCT_PATH.test(url.pathname)) {
            return;
        }
        try {
            window.localStorage.setItem(KEY, JSON.stringify({
                path: url.pathname,
                back: window.location.href,
                kind: /^\/(ticket|voucher)\//.test(window.location.pathname) ? 'ticket' : 'booking',
                at: Date.now()
            }));
        } catch (err) {} // storage off (private mode): no arrow
    }

    // capture: before any handler that stops the click; the link itself is left alone
    document.addEventListener('click', remember, true);
    document.addEventListener('auxclick', remember, true);
})();
